import React from "react";
import { Link } from "react-router-dom";
import { VERTICALS } from "@/data/verticals";
import { ArrowUpRight } from "@phosphor-icons/react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-citirex-ink text-citirex-inv"
    >
      <div className="mx-auto max-w-7xl px-6 pb-16 pt-24 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="overline">Los Angeles · Performance Marketing</p>
            <h3 className="mt-4 font-display text-3xl font-medium leading-tight md:text-5xl">
              Lead generation, engineered <br className="hidden md:block" />
              <span className="font-editorial italic text-citirex-accent">
                like a portfolio.
              </span>
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group mt-8 inline-flex items-center gap-2 border-2 border-citirex-inv px-6 py-4 font-body text-sm font-medium text-citirex-inv transition-colors hover:bg-citirex-accent hover:border-citirex-accent"
            >
              Open a media buy
              <ArrowUpRight
                size={16}
                weight="bold"
                className="transition-transform group-hover:rotate-45"
              />
            </Link>
          </div>

          <div className="md:col-span-4">
            <p className="overline">Verticals</p>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2">
              {VERTICALS.map((v) => (
                <li key={v.slug}>
                  <Link
                    to={`/verticals/${v.slug}`}
                    data-testid={`footer-vertical-${v.slug}`}
                    className="font-body text-sm text-citirex-inv/70 transition-colors hover:text-citirex-accent"
                  >
                    {v.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Company</p>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="/how-it-works"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  How it works
                </Link>
              </li>
              <li>
                <Link
                  to="/performance"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  Performance
                </Link>
              </li>
              <li>
                <Link
                  to="/case-studies"
                  data-testid="footer-case-studies"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  Case studies
                </Link>
              </li>
              <li>
                <Link
                  to="/insights"
                  data-testid="footer-insights"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  Insights
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-body text-sm text-citirex-inv/70 hover:text-citirex-accent"
                >
                  Contact
                </Link>
              </li>
            </ul>

            <p className="overline mt-8">Contact</p>
            <p className="mt-3 font-body text-sm text-citirex-inv/70">
              Citirex LLC<br />
              15165 Ventura Blvd, Suite 225<br />
              Sherman Oaks, CA 91403
            </p>
            <a
              href="tel:+18188532332"
              data-testid="footer-phone"
              className="mt-2 inline-block font-body text-sm text-citirex-inv hover:text-citirex-accent"
            >
              (818) 853-2332
            </a>
          </div>
        </div>

        <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <p className="font-body text-xs text-citirex-inv/50">
            © {year} Citirex LLC. All rights reserved. Lead products comply
            with TCPA, CCPA, GLBA & state-specific marketing regulations.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="font-body text-xs text-citirex-inv/50 transition-colors hover:text-citirex-accent"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms"
              className="font-body text-xs text-citirex-inv/50 transition-colors hover:text-citirex-accent"
            >
              Terms
            </Link>
            <Link
              to="/ccpa-opt-out"
              data-testid="footer-ccpa"
              className="font-body text-xs text-citirex-inv/50 transition-colors hover:text-citirex-accent"
            >
              CCPA Opt-Out
            </Link>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="pointer-events-none select-none px-2 pb-2 text-center font-display font-semibold leading-none tracking-tighter text-white/[0.06]"
        style={{ fontSize: "clamp(80px, 18vw, 320px)" }}
      >
        CITIREX
      </div>
    </footer>
  );
};

export default Footer;
